<template>
  <div class="elst-button" :class="buttonClass" v-if="type !== 'none'">
    <div class="elst-button__content" :class="[{ disabled: disabledValue }]" @click="handle">
      <!-- <div class="button" v-if="type == 'play'"></div>
      <div class="button" v-if="type == 'pause'"></div>
      <div class="button" v-if="type == 'prev'"></div>
      <div class="button" v-if="type == 'next'"></div>
      <img
        src="@/assets/images/Icon_Record_Stop.gif"
        v-if="type == 'stopRecord'"
        alt=""
      />
      <img
        src="@/assets/images/Icon_Score_Loading.gif"
        v-if="type == 'loading'"
        alt=""
      />-->

      <img :src="icon" :class="`img-${type}`" alt="" />
    </div>
    <div class="elst-button__text" v-if="buttonText">{{ buttonText }}</div>
  </div>
</template>

<script>
const types = ["play", "pause", "record", "stopRecord", "loading", "prev", "next", "strokes", "playHsk", "none"];
export default {
  name: "buttonUi",
  props: {
    type: {
      type: String,
      default: "",
    },
    handle: {
      type: Function,
      default: () => {},
    },
    text: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: {
        play: require("@/assets/images/btn-play.png"),
        playDisabled: require("@/assets/images/btn-play-disabled.png"),
        pause: require("@/assets/images/btn-pause.png"),
        next: require("@/assets/images/btn-next.png"),
        nextDisabled: require("@/assets/images/btn-next-disabled.png"),
        prev: require("@/assets/images/btn-prev.png"),
        prevDisabled: require("@/assets/images/btn-prev-disabled.png"),
        record: require("@/assets/images/btn-record.png"),
        stopRecord: require("@/assets/images/Icon_Record_Stop.gif"),
        loading: require("@/assets/images/Icon_Score_Loading.gif"),
        // strokes: require('@/assets/images/btn-strokes.png'),
        playHskDisabled: require("@/assets/images/play_hsk.png"),
        playHsk: require("@/assets/images/play_hsk.png"),
      },
    };
  },
  computed: {
    buttonClass() {
      if (types.includes(this.type)) {
        return "elst-button__" + this.type;
      } else {
        throw new Error(`Type does not exist (${types.join(",")})`);
        return "";
      }
    },
    disabledValue() {
      return this.disabled;
    },
    buttonText() {
      return this.text;
    },
    icon() {
      if (this.icons.hasOwnProperty(this.type)) {
        if (this.disabled) {
          return this.icons[`${this.type}Disabled`];
        } else {
          return this.icons[this.type];
        }
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.elst-button {
  display: flex;
  align-items: center;
  &:last-child {
    margin-right: 0;
  }
  &__content {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 0.9;
    }
    &.disabled {
      cursor: auto;
    }
  }
  img,
  .button {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  // &__stopRecord &__content{
  //   position: relative;
  //   &::before,
  //   &::after{
  //     left: 50%;
  //     top: 50%;
  //     transform: translate(-50%,-50%);
  //     position: absolute;
  //     content: '';
  //     width: 70px;
  //     height: 70px;
  //     border: 1px solid red;
  //     animation: recording 1.5s infinite;
  //     border-radius: 50%;
  //   }
  //   &::after{
  //     animation-delay: .5s;
  //   }
  //   @keyframes recording{
  //     0% {
  //         transform:translate(-50%,-50%) scale(1);
  //         opacity: 0;
  //     }
  //     30% {
  //         transform:translate(-50%,-50%) scale(1.1) ;
  //         opacity: 1;
  //     }
  //     100% {
  //         transform:translate(-50%,-50%) scale(1.3);
  //         opacity: 0;
  //     }
  //   }
  // }
  img.img {
    &-stopRecord {
      width: 80px;
      height: 80px;
    }
    &-loading {
      // width: 64px;
      // height: 64px;
    }
    &-stop {
    }
  }
  &__text {
    margin-left: 12px;
    margin-right: 10px;
    font-size: 24px;
  }
  & > &__content {
    &::after {
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  // &__play > &__content {
  //   .button {
  //     background-image: linear-gradient(to top right, #4095fe, #4dc6ff);
  //   }
  //   &::after {
  //     width: 21px;
  //     height: 28px;
  //     background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAcCAYAAACOGPReAAACG0lEQVRIiY3VsY7UMBCA4X+82W1WOmhAdHQnUVJRgGgoaECiOCEEFQWIAh4AHoCGBwDe4FqKEw3dUYAQICokSigQWwG6O3b3Yg+FncRJ7Gwseb0eOZ+ScTyRlVWALeAhsA18AZ4DSyHROsFpYpEE9C1wMYp/ErgB/BgCh9A5cABggUlz/QLYAfZzYA41QFFN/lk4svX1p4E3wP0cmAljugEFDmw9nSG8xOd4OgbsofHCQ+vTEdoD/F2f2gS20HihhJ+Vg7Wrw5eBDwLnN5geTYFVrFSPh/BZ/MbdHERTIJ2YU1g2uZgDu8BTEntCLyitoTdGsACPBV5ZZSuPbgCrceXAaj2/BryzynYfHQlK+GNVOVatjHPAe6tcbdBEDodAwWOqsHY1fBLYc8o9AFk7PQH8Bn+ixoDdNVMj1XwJzHu7lwPJgCZ6/YCPRnAFUeuCRGAqLYVp5W8fX4DSJ6oKyAA4NRKDL4ArRlhAqFD5E9UHDVA0OTwGHhlfdOrWf/wBcCIwkRpcADtGQr2N0dZjD4CFgGnAz/gvw/cuWD1N+04T4MxIDO4Cl3JgD82BYe6AJ8Bt4CgHQiqnYax2OMz/AHeAvSGsh8ZgtSFh/g2fv69jQOgU6eruIvA1cCEHZj98Aof4zqx5/xB4Blwn1IWxIAClU0qnd0unf0unWjr9ZZ3esk7JdRd11X6XsilfM+CMwE/8SUm29Hvdbv8BirS/arLuIqgAAAAASUVORK5CYII=)
  //       no-repeat 0 0;
  //   }
  // }
  // &__pause > &__content {
  //   .button {
  //     background-image: linear-gradient(to top right, #4095fe, #4dc6ff);
  //   }
  //   &::after {
  //     width: 20px;
  //     height: 27px;
  //     background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAbCAYAAAB836/YAAABY0lEQVRIia2WO0oEQRCGv2p3WQNBRDyBiqgXMBCvIJgbeQAPJsYGm5htbGJkLMqqCD7YxZ4ug3n3vLZnd6Bg+P+ej6rqrmZkHinJsw18AlEqCN5TETJ1ayh8ABjgGHgE3oBn4CIAdglMBd6t8mCVPZlHOnFw8hvByMBQ+BbYAWYdsE3g1TpGVmHdgAhjAxzOkiLnDgQ2gN0OGMCREMME+Iu1g0FDVaYNlshr2bvkS01jIu2wkhBriqTA3jDKMAAjvhkAw4OBX3IwLPcqPSw2ti8sB64IFgOXgNXBTZPRBwY15zAElun+RHTBZAFY96R06E2JtGbYa5dLRsEN7WWpZP/G6AvLgKuCVW4bQSsftMHq/MIuLw/LgCksdAQrvsCgrXdBIyh5hl/p2Sksmi4Ae/FhwA/W6bV1qmlETm8ipzSFK8edU9UknFO9EusU4Aw4FXgCbin8PbS2QBgC58A+cC8w+QdWxXyoPKdU4gAAAABJRU5ErkJggg==)
  //       no-repeat 0 0;
  //   }
  // }
  // &__prev > &__content {
  //   .button {
  //     box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.05);
  //     background-color: #fff;
  //   }
  //   &.disabled::after {
  //     background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAbCAYAAACEP1QvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBOEZFQkRBQUQzMzUxMUU3OEEyRUFEOERDMUI4NDJERiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBOEZFQkRBQkQzMzUxMUU3OEEyRUFEOERDMUI4NDJERiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkE4RkVCREE4RDMzNTExRTc4QTJFQUQ4REMxQjg0MkRGIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkE4RkVCREE5RDMzNTExRTc4QTJFQUQ4REMxQjg0MkRGIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+SC2AoAAAAdRJREFUeNrEl79Lw0AUx5NYUFT8gZODi78HtUNVBHVUBFEQQRQH/wWHggqCDg51cHB3EBV/o3XSQXBTBEtRURCq6K4ItkqHlvo9eAchNMmlTS8PPlzaPvK55F5yr+rdQ0zJI+rAKIiDk0B7Q8IsMfL4WothDCTBMXJ/1DzkU2ADlNLne9CJk6ayiJl0E1TQVy/A78tBWgRCIGj43g+awbNOqmFYBotA1eW2gCan8hqwBwYsJsbFlRi2wYhJrupE3gFOQb1dIsStGMJ0haahCYonwLWgmF3prZ1YRM7Xdx+UCUxyDpzpCssyrG57NdgFQw6WZtpJAZnJ22h9G5UCRrbbPg5uCi02ytnxCjgC5YqE4Le9CuyAYUVi+IhLEFAkh0abg3Qxl7/Ts+mJPEMVvkrHUuUs0mCetslf2XIeB6AXvHkh501BNz0B0uUsvuidvuaFnNdBkDaLP8HzLYGEG3IebGfrAx8CuWwz6gExt+Qsoqw5BFd2iWggn6hmzt2Ss/gEg2BdYALf1LuFrN4dmsMaYW3xLJih/tsYSd0E0mABh5MmdZDScizULdBvqINwtrXGBA7p3aH/7YL17mqe/1hKaH3jkERtGstiDF10dyLIz/wLMADqvGwLc+d+/gAAAABJRU5ErkJggg==);
  //   }
  //   &::after {
  //     width: 31px;
  //     height: 27px;
  //     background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAbCAYAAACEP1QvAAAEaUlEQVRIiWWXvatdRRTFf2verUT8wMrCJkSTQkwRjUK0VASJEAKipvBfEJGolSAKiljYW4hKxM/ESouAnSIoQcFCCGJ6RTBRguTuZbH3nnPu88F99955Z2bWXmvtNfN0/8f/omEQMACBh2EIybjG2ANkkKCfl+9AepzBFeTPGVzNcfJngJVTLN8uOIm4BnwK/LVROB8ACHKzADCM3M8AW2AoBxAafgr0juEGbEDPEb6XwXUoAAbZeOik0LvINznxnwGODCy0JSFaKEAWshLEFhS5EPm+h/0mwVkHN+CaGz6CuYueZ8AeoFdkf4ZrYwPmkOHOjQM0VJU1neAAJLRnHMXM4DZCHxo/zKjSmiUVsCj5gpsZeh/7BCOp0PIcAm0KSf64xIrFA96mxjb3KDjn4QOEcGKDoWS9gQwgdBj5PMGhFLzWn2bI9QdRdEZtauNQeiuaJj2h0Dc2B1KS0tLCNoRKNiB8QuHvMIfowva9GuuGWHhoTiTnA4M9zGsEZxBK4rwUMF2dACRe8OBpkwzPkmfl+UU1eYO9on2hXvatBGeBR6cEBoWyFadEDcR4cHp2R2S7phzVninWhLEpp5aAbunvFjqHfHBdoaj+j6J7pFkdXX3VNbI6z4rbD1q2t1Pz2UoWhE4p+JbgIBYucxHg6DbK8hTZFXIu3n4gwF1UVNvWuGq+gYHrwQTyKuFPgBuJcrFdlZapJghViOR8ORlweLVRPmOvijMJKFS041sIPkA8xqjq5ESp8kCZyqMqbg90+HQ8TxmXtFRbaTi7XanHRuGNhy6Aj0JNZLXQDBI6PFLrKDO4jKXF1hq7Zp/mm2bMNTa27lBwtJGhdnAvnEZpACpjzqpG6VybKeg2nQzm/AK2YmQQ/GbzxczuUB0yZjen2fmsOge8DqnSnf+NeWXE3CM3B2NOEXpDlgnwPGhWGsbiWEKw9a7mmW4T1EzHGpvzGzxi1OSt4EUHT2H+bgqXRZd3r74r9i26YsbT5arPu0w6zHAhdA5+hH2c4NeJsCstGRSrdmtAk35Nqhfau7eFwitJ1H1efwQI/Yh1TMGFXnihnypJO3RrtVED0T4AhDtP5isvE05n97kt+w9bj8q89X8Jqgv2SaLQSucFwAIyK1/7YVV5099pxtah5wlOY/7Zcf6KWq9ZCV4mdLWPY4dhm2uqI7cjO2DMU82dWF5oBLDOEnoQc3m3A7qaFeXWOYcfILjUZ3xnvKMPJCZzg87vVf7aq8DKxS8S3Evwdd732DEOVUleMvQzoWPYX2rLcuC0FCs5hvrAaEoaQDm300v27zKPYN6e412FlxApU/6JdcLmdRm3PFoFjK084jU1d6FvNjT72ple122eJXjG5tp+CRy6xrLBVsFLNk9irs52rnZTcH3sv8W402F+Zt7nVtH6nsxDCi6vzHde4Uu7gSMIPiZ0nODS6t7wFcEvm75cLodS37A8f7sRzrPR2Poe+zDiGOIKcBEydvs/H1SuFz9J3A26D3ON4AeE/wMo5p4KH8ks7gAAAABJRU5ErkJggg==);
  //   }
  // }
  // &__next > &__content {
  //   .button {
  //     box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.05);
  //     background-color: #fff;
  //   }
  //   &.disabled::after {
  //     background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAbCAYAAACEP1QvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBMDAzODI0Q0QzMzUxMUU3QThBNEI3NTJGNUVDNkZGQyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBMDAzODI0REQzMzUxMUU3QThBNEI3NTJGNUVDNkZGQyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkEwMDM4MjRBRDMzNTExRTdBOEE0Qjc1MkY1RUM2RkZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkEwMDM4MjRCRDMzNTExRTdBOEE0Qjc1MkY1RUM2RkZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+B1ZYWgAAAZ1JREFUeNpiPHPpDgMQ8AJxMBBzAvFqIH7DgBuA1AQBsQAQbzHWVX7IQCZgBFoOMuwcEGtAxT4AcQwQb8WinhmIjwOxKZT/FYhTgA5YQY7lTECsj2QxA9RHm4C4BuQ4NPVSSBaDADcQLzt7+W4XEDOTYzkLDvFmIF4LjRJ4SGELPSAuBeLtQAcIk2o5PhAIxCeAWI0Is1yB+BTQAfrUshwEtID4JBB7E6FWCYiPAh0QQS3LkdNBBRFqiU4HTCRGUSaxuYiYdMDEQFuANx3Q2nK86YAeluNMB/SyHGs6oKflyOlgP9ABHANhOQjoArH6QFl+AIivDoTl04HYDVgT/mGho6U/gTgbaOlcmAC9LH8KaqwALT5J73x+FIhN0C2mh+Wg+HUEWvwCmyQpwf4FiBuBuJuc+KWkbL8LxNZAvIrI+LUnZDGxlu8EYjMgvkRJ/JJq+X8g7oS2YN5RGr+44vwHjvhNxhLMf8mNX1w+Pw/Ee5DEbuKJ36fQTgUMPCY2fnF1GmDVnTEQc0Abi78J6DOENqnPAC3+Rm4+BAgwAPsqe9KTe8HRAAAAAElFTkSuQmCC);
  //   }
  //   &::after {
  //     width: 31px;
  //     height: 27px;
  //     background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAbCAYAAACEP1QvAAAEXklEQVRIiWWWsateRRDFf2ffKxIkELCzTKFBkCAaFVKEFLFJpRFJYWcaTR2wsLPSfyBVWpEEC6MigqDNQyOiIFhYWIgEUohYREmIO8diZvfu9/Lg8u53996dM2fOnFm99Ol9aDqGfNHiKI2biD8RaM9YBgnG/+ajiFcRxxGfIX5f1gBA5G+c93k3brffL37y4CjiR5pP0gD5b8QbND5HkM/mtUfjW4nTbgbpH+TLiI+WdxIo9e34WyMzloNTBCcVQADRjhO6pdC7CqRQPQfME4RPOwwh6H6M4EOCDwj2MBDOtFC+4y1VL4ENNDr7GXgEMQqaO+859LE7x7Y1RIgEZGRBSARXMV8QPD6B9orgAuAixFsJmpwvu+cH6om4AL1C8B2dJxcAOPIdB2DXc50n+B50Cm+FTpaYAFir4q4MauaG7glPYWSelrlNcIFeACqgAugCCyXdJwgOCF2iJ1BZlb2wKcB5NYUzk56b5SXcqUu46zjBLcw7hFBPZsZG8z6v1IEXHQywHoqs4IPiQeWgV5N6Z1ZBo/PWDNRH7UdgJQupB2lHByoA3kqXwYueqjlrFs4ALpGNjhgAXCAJZasXC0RSrCB1EJxKALVH7dt2xFAqVQy6N0B0byIrIAov62zCip0kTmAdYF3aWR+0zw/nVZl0zUxHYE0AW4ZJY+3Thw5KaAlyVwczeB/1Wnv9UJ8u7ee+gWEpx86zPnQxQAuMCKUOnH7QNho0s9lhoS9UlcrpW80z2wQ4WsnemFnLUNd5gq8xR/YJpQdHdb/IdpCHB6ZZtJoVbN2isa7yLAu17TuPvVppowFNYJ7Bfmp/erGUC8N+NEAZWtVwXTN4rzLfK3/Q2ErT3gdIjwQT5zc0fmlJd/Wht7rtKLhr69E+hJcdMBQ/RKhDZduZG1nCazIvE/ovh4rKZJy0C7GZUdFW7+X6kkkrHVSKNqgJ2bjlnm6A9UDNV+hcd43qfUdt7lmPjbJRY2ur7aB2vp8HCQ/ge2U+w0UlBHcsXzS6LbnKYvbnVFIOB9cBpPJLysSWSfMj9XexNYUnb8AaB4bXEHfl/H6w1oYZ5IBZ2urQNdtnTLbFnA4Nlq3frWuEzhG6qyqrpy+oTl3lUOKQ4JYDBsE9Qlc1/WAB4FVYRsEDwpfpvE3o4fSFYVBl3S1HXfXyVL0T3Tx96DdCZwjfcN8m03TAmmg17e4QnKXreg4sb4NrTj4X7WOoLMccDa/OIF8SvEDw8zgU7FC7tKSCA4LnCW6vJ551BqzO1xiCXRcThB16H3MB89fQwjjx4NHf43TDNYJzhO7O8bmUZBxAxrRTF/s299djrRA29zBvqvmGQ0jZBRLd4/SHsp2CB266Qvi6pLThIdCmHMUC9kqsDUS2Z5P4CfhqHmvNr8AZIAMvZcHcIXRzHjrNH4TPEr6+DqJN+d5xt6TeUx/7ho55WeI54AjmNvBwmBserlUd0Xjd5lnMMeAHo3+nuz3iitoxq2lM9fh/3ziCXvtOqkcAAAAASUVORK5CYII=);
  //   }
  // }
}
</style>
